<template>
	<div class="">
		<div class="container">
			<div class="row">
				<div class="col-md-1"></div>
				<div class="col-md-10">
					<br />
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12">
								<div class="card">
									<div class="container">
										<div class="card-content">
											<h1
												class="earth-color heading text-md-center text-lg-center text-sm-center"
											>
												Payment Card Declined.
											</h1>
											<p>
												Hello
												<span style="text-transform: capitalize">{{
													singleBooking.booking_details.first_name
												}},</span>
											</p>
											 
											<p>
												We are having trouble processing your payment for the booking with booking reference <strong>#{{singleBooking.booking_ref_code}}.</strong>
											</p>
										
											<p>The reason the payment cannot be processed is <strong>{{ bookingPaymentFailure.reason }}.</strong> </p>
												<p><strong><a class="knockout-color" :href="paymentUrl">Retry with a different payment method.</a></strong>
											<br />
											<p>For any enquiry please get in touch with us via  <strong><a class="knockout-color" :href="'mailto:' + email">{{email}}</a></strong> or call us on <strong  class="knockout-color"> +254 (0) 707 187 141</strong>
											</p>
											<h4>Thank you from the Ol Pejeta Team!
											</h4>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />
		<br />
		<br />
		<br />
	</div>
</template>

<script>
import { urls } from "../../../vuex/urls";
// const liveServer = urls.developmentUrl + ':5005/'
export default {
	data() {
		return {
			email:"reservations@olpejetaconservancy.org",
			liveServer: urls.developmentUrl+'/payment/info/'
		};
	},
	created() {
		this.$store.dispatch("get_booking", this.$route.params.booking_id);
		this.$store.dispatch("get_booking_payment_failure", this.$route.params.booking_id);
	},

	computed: {
		bookingPaymentFailure: function() {
			return this.$store.state.BookingStore.payment_failure;
		},
		paymentUrl: function(){
	   let url = this.liveServer
		 let booking_public_id = this.singleBooking.booking_public_id
		 let payment_url = url+booking_public_id
		 return payment_url
	}
	}
};
</script>

<style scoped>
p {
	font-size: 140%;
}
a:hover {
 
	text-decoration: none  !important;
	color:green
}
li {
	text-decoration: none;
	list-style: none;
}
.activity {
	padding-bottom: 1%;
	padding-top: 1%;
	padding-left: 2%;
	border: 1px solid gray;
}

#side {
	z-index: 100;
	margin-top: -10%;
	position: absolute;
	/**/
	background-color: white;
}

/* Dropdown Button */

/* The container <div> - needed to position the dropdown content */
.dropdown {
	position: relative;
	display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 160px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
	z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
	color: black;
	padding: 12px 16px;
	text-decoration: none;
	display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
	background-color: #f1f1f1;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
	display: block;
}
</style>
